<template>
	<div>
		<Loader v-if="loading" />
		<label for="">Country Id</label>
		<input type="text" placeholder="Country Id" v-model="country_id">
		<br>
		<label for="">User Id</label>
		<input type="text" placeholder="User Id" v-model="user_id">
		<br>
		<label for="">SSN</label>
		<input type="text" placeholder="SSN" v-model="ssn">
		<br>
		<label for="">Name</label>
		<input type="text" placeholder="Name" v-model="name">
		<br>
		<label for="">Address</label>
		<input type="text" placeholder="address" v-model="address">
		<br>
		<label for="">House number</label>
		<input type="text" placeholder="house number" v-model="house_number">
		<br>
		<label for="">House number extension</label>
		<input type="text" placeholder="house number extension" v-model="house_number_extension">
		<br>
		<label for="">Phone</label>
		<input type="text" placeholder="Phone" v-model="phone">
		<br>
		<label for="">Post Code</label>
		<input type="text" placeholder="Post code" v-model="postCode">
		<br>
		<label for="">Sex</label>
		<input type="text" placeholder="Sex" v-model="sex">
		<br>
		<label for="">Date of birth (yyyy-mm-dd)</label>
		<input type="text" placeholder="Date of birth" v-model="dob">
		<br>
		<label for="">Request</label>
		<textarea v-text="JSON.stringify(request, undefined, 4)" name="request" id="req" cols="30" rows="10">
		</textarea>
		<br>
		<br>
		<button @click="getFieldInfo()">Get Required Field Info</button> &nbsp;&nbsp;
		<button @click="getCustomerInfo()">Get Customer Info</button>&nbsp;&nbsp;
		<button @click="checkCredit()">Check Credit</button>&nbsp;&nbsp;
		<br>
		<br>
		<button @click="getCustomerRequiredFieldInfo()">Required customer existing data</button>&nbsp;&nbsp;
		<!--<button @click="updateInfoAndCheckCredit()">Update info and check credit</button>&nbsp;&nbsp;-->
		<br>
		<br>
		<br>
		<label for="">Response</label>
		<textarea v-text="response" name="request" id="res" cols="50" rows="30">
		</textarea>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'CreditCheck',
  data: () => ({
    loading: false,
    country_id: 1,
    user_id: 12038,
    ssn: '',
    name: '',
    address: '',
    house_number: '',
    house_number_extension: '',
    postCode: '',
    phone: '',
    sex: '',
    dob: '',
    return_data: true,
    response: '',
    responseText: ''
  }),
  methods: {
    checkCredit () {
      Vue.$api.post('/credit-verification/verify', this.request, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.response = JSON.stringify(data, undefined, 4)
        }
      })
    },
    /* updateInfoAndCheckCredit() {
				Vue.$api.post('/credit-verification/verify', this.request, {
					before: () => this.loading = true,
					always: () => this.loading = false,
					callback: (data) => {
						this.response = JSON.stringify(data, undefined, 4);
					},
				});
			}, */
    getCustomerInfo () {
      Vue.$api.post('/credit-verification/customer-basic', this.request, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.response = JSON.stringify(data, undefined, 4)
        }
      })
    },

    getFieldInfo () {
      Vue.$api.get('/credit-verification/' + this.country_id + '/form-field-info', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.response = JSON.stringify(data, undefined, 4)
        }
      })
    },

    getCustomerRequiredFieldInfo () {
      Vue.$api.get('/credit-verification/customer/required-info?user_id=' + this.user_id + '&country_id=' + this.country_id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.response = JSON.stringify(data, undefined, 4)
          this.responseText = data
        }
      })
    }
  },
  computed: {
    request () {
      return {
        country_id: this.country_id,
        user_id: this.user_id,
        ssn: this.ssn,
        name: this.name,
        address: this.address,
        house_number: this.house_number,
        house_number_extension: this.house_number_extension,
        phone: this.phone,
        post_code: this.postCode,
        sex: this.sex,
        date_of_birth: this.dob,
        return_data: true
      }
    }
  }
}
</script>

<style scoped>

</style>
